const Util = require('../../util');
const { default: Log } = require('../../../common/log');
const Constants = require('../../constants');
const { AnalyticsTag } = require('../../../common/Constants');

var NpawVideoAdsGettersMixin = {
  /**
   * Returns ads's PlayerVersion
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdPlayerVersion: function () {
    return this._safeGetterAdsAdapter('getPlayerVersion') || '';
  },

  /**
   * Returns ad's position
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdPosition: function () {
    let ret = Constants.AdPosition.Preroll;
    let adapterReturnedValue = false;
    if (this._adsAdapter) {
      try {
        var temporalRet = this._adsAdapter.getPosition();
        if (
          Constants.AdPosition.Preroll === temporalRet ||
          Constants.AdPosition.Midroll === temporalRet ||
          Constants.AdPosition.Postroll === temporalRet
        ) {
          ret = temporalRet;
          adapterReturnedValue = true;
        }
      } catch (err) {
        Log.warn(AnalyticsTag, 'An error occured while calling getAdPosition', err);
      }
    }
    if (!adapterReturnedValue && this._adapter) {
      ret = this._adapter.flags.isJoined ? Constants.AdPosition.Midroll : Constants.AdPosition.Preroll;
    }
    return ret;
  },

  getAdNumber: function () {
    return this.requestBuilder.lastSent.adNumber || 0;
  },

  getAdNumberInBreak: function () {
    return this.requestBuilder.lastSent.adNumberInBreak || 0;
  },

  getBreakNumber: function () {
    return this.requestBuilder.lastSent.breakNumber || 0;
  },

  /**
   * Returns ad's AdPlayhead
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdPlayhead: function () {
    const ret = this._safeGetterAdsAdapter('getPlayhead');
    return Util.parseNumber(ret, 0);
  },

  /**
   * Returns ad's AdDuration
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdDuration: function () {
    const ret = this._safeGetterAdsAdapter('getDuration', 'ad.duration');
    return Util.parseNumber(ret, 0);
  },

  /**
   * Returns ad's AdBitrate
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdBitrate: function () {
    let ret = this._safeGetterAdsAdapter('getBitrate');
    if (!ret || ret === -1) {
      ret = this.getWebkitAdBitrate();
    }
    return Util.parseNumber(ret, -1);
  },

  /**
   * Returns bitrate as per webkitVideoDecodedByteCount
   *
   * @returns {number}
   *
   * @memberof npaw.Plugin.prototype
   */
  getWebkitAdBitrate: function () {
    try {
      if (this._adsAdapter && this._adsAdapter.tag && this._adsAdapter.tag.webkitVideoDecodedByteCount) {
        let bitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
        if (this._lastWebkitAdBitrate) {
          const delta = this._adsAdapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate;
          bitrate = Math.round(((delta) / this.plugin.fastDataTransform.response.pingTime) * 8);
        }
        this._lastWebkitAdBitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount;
        return bitrate !== 0 ? bitrate : -1;
      }
    } catch (e) {
      /* empty */
    }
    return -1;
  },

  /**
   * Returns ad's AdTitle
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdTitle: function () {
    return this._safeGetterAdsAdapter('getTitle', 'ad.title');
  },

  /**
   * Returns ad's AdResource
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdResource: function () {
    return this._safeGetterAdsAdapter('getResource', 'ad.resource');
  },

  /**
   * Returns ad's campaign
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdCampaign: function () {
    return this._safeGetterAdsAdapter('getCampaign', 'ad.campaign');
  },

  /**
   * Returns ad's campaign
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdCreativeId: function () {
    return this._safeGetterAdsAdapter('getCreativeId', 'ad.creativeId');
  },

  /**
   * Returns ad's provider
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdProvider: function () {
    return this._safeGetterAdsAdapter('getProvider', 'ad.provider');
  },

  /**
   * Returns ads adapter getVersion or null
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdAdapterVersion: function () {
    return this._safeGetterAdsAdapter('getVersion');
  },

  /**
   * Returns ad's AdMetadata
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdMetadata: function () {
    return this.options['ad.metadata'];
  },

  /**
   * Returns the type of ad insertion (clientside, serverside)
   * @returns {string} ad insertion type
   */
  getAdInsertionType: function () {
    return this._safeGetterAdsAdapter('getAdInsertionType');
  },

  getGivenBreaks: function () {
    return this._safeGetterAdsAdapter('getGivenBreaks', 'ad.givenBreaks');
  },

  getExpectedBreaks: function () {
    let ret;
    const expBreaks = this.options['ad.expectedBreaks'];
    const expPattern = this.options['ad.expectedPattern'];
    if (expBreaks) {
      ret = expBreaks;
    } else if (expPattern) {
      ret = 0;
      ret = expPattern.pre ? expPattern.pre.length : 0;
      ret += expPattern.mid ? expPattern.mid.length : 0;
      ret += expPattern.post ? expPattern.post.length : 0;
    } else if (this._adsAdapter) {
      try {
        ret = this._adsAdapter.getExpectedBreaks();
      } catch (err) {
        Log.warn(AnalyticsTag, 'An error occured while calling expectedBreaks', err);
      }
    }
    return ret;
  },

  getExpectedPattern: function () {
    return this._safeGetterAdsAdapter('getExpectedPattern', 'ad.expectedPattern');
  },

  getBreaksTime: function () {
    return this._safeGetterAdsAdapter('getBreaksTime', 'ad.breaksTime');
  },

  getGivenAds: function () {
    return this._safeGetterAdsAdapter('getGivenAds', 'ad.givenAds');
  },

  getExpectedAds: function () {
    let ret;
    try {
      if (this._adsAdapter) {
        const pattern = this.options['ad.expectedPattern'];
        if (pattern && this.getAdPosition()) {
          let list = [];
          if (pattern.pre) list = list.concat(pattern.pre);
          if (pattern.mid) list = list.concat(pattern.mid);
          if (pattern.post) list = list.concat(pattern.post);
          if (list.length > 0) {
            let position = this.requestBuilder.lastSent.breakNumber;
            if (position > list.length) position = list.length;
            ret = list[position - 1];
          }
        } else {
          ret = this._adsAdapter.getExpectedAds();
        }
      }
    } catch (err) {
      Log.warn(AnalyticsTag, 'An error occured while calling expectedAds', err);
    }
    return ret;
  },

  getAdsExpected: function () {
    let ret;
    try {
      ret = this.getExpectedPattern() || this.getGivenAds() || false;
    } catch (err) {
      Log.warn(AnalyticsTag, 'An error occured while calling givenAds or expectedPattern', err);
    }
    return ret;
  },

  // ----------------------------------------- CHRONOS ------------------------------------------

  /**
   * Returns AdJoinDuration chrono delta time
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdJoinDuration: function () {
    if (!this._adsAdapter) {
      Log.warn(AnalyticsTag, '[' + this.getViewCode() + '] getAdJoinDuration called but NO ADS ADAPTER exists!');
      return -1;
    }
    
    const baseAdJoinTime = this._adsAdapter.chronos.join.getDeltaTime(false);
    
    // When new calculation is enabled and this is a pre-roll ad with initial buffering time (T1),
    // add T1 to the ad join time to match Android behavior: adJoinTime = T1 + T2
    const shouldAddT1 = this.getJoinTimeMeasureAfterAdBreak() === true && 
                        this.requestBuilder.lastSent.position === Constants.AdPosition.Preroll &&
                        this._initialPrerollTime > 0;
    
    if (shouldAddT1) {
      // If baseAdJoinTime is -1 (chrono not started), treat T2 as 0
      // This can happen if adJoin fires before chrono is properly started
      const t2 = baseAdJoinTime >= 0 ? baseAdJoinTime : 0;
      const result = this._initialPrerollTime + t2;
      Log.debug(AnalyticsTag, '[' + this.getViewCode() + '] getAdJoinDuration - NEW calculation: T1(' + this._initialPrerollTime + ') + T2(' + t2 + ') = ' + result);
      return result;
    }
    
    Log.debug(AnalyticsTag, '[' + this.getViewCode() + '] getAdJoinDuration - OLD calculation: T2(' + baseAdJoinTime + '), measureAfterAdBreak=' + this.getJoinTimeMeasureAfterAdBreak() + ', position=' + this.requestBuilder.lastSent.position + ', T1=' + this._initialPrerollTime);
    return baseAdJoinTime;
  },

  /**
   * Returns AdBufferDuration chrono delta time
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdBufferDuration: function () {
    return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(false) : -1;
  },

  /**
   * Returns AdPauseDuration chrono delta time
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdPauseDuration: function () {
    return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(false) : 0;
  },

  /**
   * Returns total totalAdDuration chrono delta time
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdTotalDuration: function () {
    return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(false) : -1;
  },

  getAdViewedDuration: function () {
    return this._getTimeMaxOrAcum(true);
  },

  getAdViewability: function () {
    return this._getTimeMaxOrAcum();
  },

  _getTimeMaxOrAcum: function (acum) {
    let maxTime = 0;
    if (this._adsAdapter) {
      this._adsAdapter.chronos.viewedMax.forEach(function (chrono) {
        if (acum) {
          maxTime += chrono.getDeltaTime(false);
        } else {
          maxTime = Math.max(chrono.getDeltaTime(false), maxTime);
        }
      });
    }
    return maxTime;
  },

  getAudioEnabled: function () {
    return this._safeGetterAdsAdapter('getAudioEnabled');
  },

  getIsSkippable: function () {
    return this._safeGetterAdsAdapter('getIsSkippable');
  },

  getIsFullscreen: function () {
    return this._safeGetterAdsAdapter('getIsFullscreen');
  },

  _safeGetterAdsAdapter: function (func, option) {
    let ret;
    if (option && this.options[option]) {
      ret = this.options[option];
    } else {
      try {
        if (this._adsAdapter && typeof this._adsAdapter[func] === 'function') {
          ret = this._adsAdapter[func]();
        }
      } catch (err) {
        Log.warn(AnalyticsTag, 'An error occured while calling ' + func, err);
      }
    }
    return ret;
  },

  /**
   * Creates an adnumber if it does not exist and stores it in lastSent. If it already exists,
   * it is incremented by 1.
   *
   * @returns {number} adNumber
   */
  getNewAdNumber: function () {
    let adNumber = this.requestBuilder.lastSent.adNumber;
    if (adNumber && this.requestBuilder.lastSent.position === this.getAdPosition()) {
      adNumber += 1;
    } else {
      adNumber = 1;
    }
    this.requestBuilder.lastSent.adNumber = adNumber;
    return adNumber;
  },

  /**
   * Creates an adnumberinbreak incrementing by 1.
   *
   * @returns {number} adNumber
   */
  getNewAdNumberInBreak: function () {
    this._adNumberInBreak++;
    this.requestBuilder.lastSent.adNumberInBreak = this._adNumberInBreak;
    return this._adNumberInBreak;
  },

  /**
   * Creates an breaknumber if it does not exist and stores it in lastSent. If it already exists,
   * it is incremented by 1.
   * Also resets adnumberinbreak
   * @returns {number} breakNumber
   */
  getNewBreakNumber: function () {
    let breakNumber = 1;
    this._adNumberInBreak = 0;
    if (this.requestBuilder.lastSent.breakNumber) {
      breakNumber = this.requestBuilder.lastSent.breakNumber + 1;
    }
    if (breakNumber && this.requestBuilder.lastSent.position !== this.getAdPosition()) {
      breakNumber = 1;
    }
    this.requestBuilder.lastSent.breakNumber = breakNumber;
    return breakNumber;
  },

  /**
   * Returns ad's Extraparam1
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam1: function () {
    return this.options['ad.customDimension.1'];
  },

  /**
   * Returns ad's Extraparam2
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam2: function () {
    return this.options['ad.customDimension.2'];
  },

  /**
   * Returns ad's Extraparam3
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam3: function () {
    return this.options['ad.customDimension.3'];
  },

  /**
   * Returns ad's Extraparam4
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam4: function () {
    return this.options['ad.customDimension.4'];
  },
  /**
   * Returns ad's Extraparam5
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam5: function () {
    return this.options['ad.customDimension.5'];
  },

  /**
   * Returns ad's Extraparam6
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam6: function () {
    return this.options['ad.customDimension.6'];
  },

  /**
   * Returns ad's Extraparam7
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam7: function () {
    return this.options['ad.customDimension.7'];
  },

  /**
   * Returns ad's Extraparam8
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam8: function () {
    return this.options['ad.customDimension.8'];
  },

  /**
   * Returns ad's Extraparam9
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam9: function () {
    return this.options['ad.customDimension.9'];
  },

  /**
   * Returns ad's Extraparam10
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdExtraparam10: function () {
    return this.options['ad.customDimension.10'];
  }
};

module.exports = NpawVideoAdsGettersMixin;

